import Dashboards from './containers/dashboards';
import NewDashboards from './containers/new-dashboard';
import Reports from './containers/reports';
import NewReports from './containers/new-report';
import Settings from './containers/settings';

import {AppSettings} from '../constants';

export default [
  {
    path: '/report-dashboards',
    component: Dashboards,
    private: true,
    menu: {
      name: 'Dashboards',
      group: 'Report',
      icons: 'pe-7s-monitor',
      order: 1
    }
  },
  {
    path: '/report-dashboards/new',
    component: NewDashboards,
    private: true
  },
  {
    path: '/report',
    component: Reports,
    private: true,
    menu: {
      name: 'Reports',
      group: 'Report',
      icons: 'pe-7s-graph2',
      order: 2
    }
  },
  {
    path: '/report/new',
    component: NewReports,
    private: true
  },
  {
    path: '/report-settings',
    component: Settings,
    private: true,
    menu: {
      name: 'Settings',
      group: 'Report',
      icons: 'icon-setting-ic',
      order: 3,
      condition: () => AppSettings.clientTypeValue === 'System'
    }
  }
];



// WEBPACK FOOTER //
// ./src/izenda/routers.js